<div class="relative overflow-hidden rounded-lg" *ngIf="images[currentSlide]" [style]="'aspect-ratio: ' + aspectClass">
  <div
    *ngIf="images[currentSlide].contentType === 'image/jpeg'"
    class="min-h-full bg-contain bg-center bg-no-repeat"
    [style]="{ 'background-image': 'url(' + images[currentSlide].url + ') ', opacity: hidden ? 0.2 : 1, transition: 'opacity ' + animationSpeed + 'ms ease-in-out 0ms'}">
  </div>

  <div
    *ngIf="images[currentSlide].contentType === 'video/h264-mp4'"
    class="min-h-full"
  >
    <video loop muted playsinline autoplay class="absolute block aspect-square object-contain ios-downloadable h-full w-full">
      <source [src]="images[currentSlide].url" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  </div>

</div>
